import React, { useState } from 'react';
import { services } from '../mockData';
import { ArrowRight, X } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../components/ui/dialog';

const Services = () => {
  const [selectedService, setSelectedService] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleServiceClick = (service) => {
    setSelectedService(service);
    setIsDialogOpen(true);
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
    setTimeout(() => setSelectedService(null), 300);
  };

  return (
    <section id="services" className="bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-2 bg-[#f4e5c3]/30 rounded-full">
            <span className="text-[#b8962e] font-semibold">Naše Usluge</span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-[#0f172a] mb-6 gold-underline">
            Sveobuhvatna Građevinska Rješenja
          </h2>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Od temelja do krova, pružamo kompletne građevinske usluge s naglaskom 
            na kvalitetu, preciznost i zadovoljstvo klijenta.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div 
              key={service.id} 
              className="service-card group cursor-pointer"
            >
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-2xl font-bold text-white mb-2">{service.title}</h3>
                </div>
              </div>
              
              <div className="p-6">
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {service.description}
                </p>
                
                <div className="space-y-2 mb-6">
                  {service.features.map((feature, index) => (
                    <div key={index} className="flex items-center gap-2">
                      <div className="w-1.5 h-1.5 bg-[#d4af37] rounded-full"></div>
                      <span className="text-sm text-gray-600">{feature}</span>
                    </div>
                  ))}
                </div>
                
                <button 
                  onClick={() => handleServiceClick(service)}
                  className="text-[#d4af37] font-semibold flex items-center gap-2 group-hover:gap-3 transition-all"
                >
                  Saznajte Više
                  <ArrowRight className="w-5 h-5" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Service Gallery Dialog */}
      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogContent className="max-w-5xl max-h-[90vh] overflow-y-auto">
          {selectedService && (
            <>
              <DialogHeader>
                <DialogTitle className="text-3xl font-bold text-[#0f172a] mb-2">
                  {selectedService.title}
                </DialogTitle>
                <DialogDescription className="text-lg text-gray-600">
                  {selectedService.description}
                </DialogDescription>
              </DialogHeader>

              <div className="mt-6">
                <h3 className="text-2xl font-bold text-[#0f172a] mb-4">Galerija Radova</h3>
                {selectedService.gallery && selectedService.gallery.length > 0 ? (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {selectedService.gallery.map((image, index) => (
                      <div 
                        key={index} 
                        className="relative rounded-lg overflow-hidden shadow-lg group cursor-pointer"
                      >
                        <img 
                          src={image} 
                          alt={`${selectedService.title} - Slika ${index + 1}`}
                          className="w-full h-80 object-cover transition-transform duration-500 group-hover:scale-110"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                          <p className="text-white p-4 font-semibold">
                            {selectedService.title} - Projekt {index + 1}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-gray-500 text-center py-8">
                    Galerija slika uskoro dostupna
                  </p>
                )}

                <div className="mt-8 bg-gray-50 rounded-xl p-6">
                  <h4 className="text-xl font-bold text-[#0f172a] mb-4">Značajke Usluge</h4>
                  <div className="grid grid-cols-2 gap-4">
                    {selectedService.features.map((feature, index) => (
                      <div key={index} className="flex items-center gap-2">
                        <div className="w-2 h-2 bg-[#d4af37] rounded-full"></div>
                        <span className="text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default Services;